module.exports = {
  entry: './src/apps/esg-ibm-flashsystems/index.tsx',
  shortcode: 'esg-ibm-flashsystems',
  title: 'ESG IBM flashsystems',
  status: 'stable',
  description: 'ESG IBM flashsystems.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=esg-ibm-flashsystems-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'ar',
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pl',
      'pt',
      'ru',
      'tr',
      'zh-cn',
      'zh-tw',
    ],
  },
};
